export default class XHR_API {
  constructor() {

  }

  getRequest(url) {
    var realUrl = url;
    return new Promise(function (resolve, reject) {
      var XMLhttpRequest = new XMLHttpRequest();
      if (XMLhttpRequest) {
        XMLhttpRequest.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            resolve(JSON.parse(this.responseText));
          } else if (this.readyState == 4 && this.status == 403) {
            SPN_Console.log("403");
          } else if (this.status != 200 && this.readyState == 4) {
            reject();
          }
        };
        XMLhttpRequest.open("GET", realUrl, true);
        XMLhttpRequest.setRequestHeader("Content-type", "application/json");
        XMLhttpRequest.setRequestHeader("security_token", "");
        XMLhttpRequest.setRequestHeader("app_version", "");
        XMLhttpRequest.setRequestHeader("build_number", "");
        XMLhttpRequest.send();
      }
    });
  }

  postRequest(url, payload) {
    var realUrl = url;
    return new Promise(function (resolve, reject) {
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          resolve(JSON.parse(this.responseText));
        }
      };
      xhttp.open("POST", realUrl, true);
      xhttp.setRequestHeader("Content-type", "application/json");
      xhttp.send(JSON.stringify(payload));
    });
  }
}
